'use strict';

require("core-js/modules/es6.regexp.split");

module.exports = blockquote;
var lineFeed = '\n';
var space = ' ';
var greaterThan = '>';

function blockquote(node) {
  var values = this.block(node).split(lineFeed);
  var result = [];
  var length = values.length;
  var index = -1;
  var value;

  while (++index < length) {
    value = values[index];
    result[index] = (value ? space : '') + value;
  }

  return greaterThan + result.join(lineFeed + greaterThan);
}